import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import './App.css'
import './Fonts.css'
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BackButton from "./components/BackButton";
import ProfileButton from "./components/ProfileButton";
import Logo from './components/Logo';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const [logoAnimate, setLogoAnimate] = useState(false);

  useEffect(() => {
    // Trigger logo animation only on pages where BackButton appears
    if (location.pathname !== '/') {
      setLogoAnimate(true);
      const timeout = setTimeout(() => setLogoAnimate(false), 400);
      return () => clearTimeout(timeout);
    }
  }, [location.pathname]);

  return (
    <div className="app-container" style={{ backgroundImage: "url('/bg.svg')" }}>
      {/* Fixed Header */}
      <header className="header">
        <div className="header-left">
          <Logo animate={logoAnimate} />
          <BackButton />
        </div>
        <ProfileButton/>
      </header>

      {/* Sidebar + Main Content */}
      <div className="content-wrapper">
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
